import {
  DocumentData,
  DocumentReference,
  DocumentSnapshot,
  getDoc,
  getDocFromCache,
  getDocs,
  getDocsFromCache,
  Query,
  QuerySnapshot,
} from 'firebase/firestore';

/** Fetches a document from cache when available, otherwise from Firestore. */
export async function fetchWithCache<T = DocumentData>(
  docRef: DocumentReference<T>,
): Promise<DocumentSnapshot<T>> {
  try {
    const snapshot = await getDocFromCache(docRef);
    if (snapshot.exists()) return snapshot;
  } catch {
    // Cache misses are expected and fall through to the server.
  }
  return getDoc(docRef);
}

/** Fetches a query from cache when available, otherwise from Firestore. */
export async function fetchDocsWithCache<T = DocumentData>(
  query: Query<T>,
): Promise<QuerySnapshot<T>> {
  try {
    const snapshot = await getDocsFromCache(query);
    if (!snapshot.empty) return snapshot;
  } catch {
    // Cache misses are expected and fall through to the server.
  }
  return getDocs(query);
}